export default __webpack_public_path__ + "5f791e6b02d3f5e4d862b408fe88ee48.mp3";